import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material_modern'
import { useController } from 'react-hook-form'

const InputV2 = ({ control, name, defaultValue, required, sx, fractionDigits, type, ...restProps }) => {
  const [editing, setEditing] = useState(false)
  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
  })
  const { value } = restProps
  const inputValue = value ?? inputProps.value

  return (
    <TextField
      sx={{ width: '100%', ...sx }}
      {...inputProps}
      inputRef={ref}
      {...restProps}
      onChange={(...args) => {
        restProps.onChange(...args)
        inputProps.onChange(...args)
        setEditing(true)
      }}
      onFocus={(...args) => {
        restProps.onFocus(...args)
        setEditing(true)
      }}
      onBlur={(...args) => {
        restProps.onBlur(...args)
        inputProps.onBlur(...args)
        setEditing(false)
      }}
      value={
        !editing && (inputValue || inputValue === 0) && fractionDigits >= 0
          ? parseFloat(inputValue).toFixed(fractionDigits)
          : inputValue
      }
      type={type}
    />
  )
}

InputV2.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** control is not required when wrapping comp uses FormProvider */
  control: PropTypes.instanceOf(Object),
  required: PropTypes.bool,
  sx: PropTypes.instanceOf(Object),
  fractionDigits: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
}

InputV2.defaultProps = {
  fractionDigits: undefined,
  required: false,
  sx: {},
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  type: 'text',
}

export default InputV2
